
import { Vue, Component, Prop } from "vue-property-decorator";
@Component({
  name: "HomeBidDia",
  components: {},
})
export default class HomeBidDia extends Vue {
  title = "立即申办";
  width = "586px";
  open = false;

  list = [];
  // 选中下标
  currActive = -1;

  show(data: any) {
    this.currActive = -1;
    this.open = true;

    this.list = JSON.parse(data.immediatelyDeclare).item || [];
  }
  close() {
    this.open = false;
  }

  pageHandle(item: any) {
    window.open(item.url);
  }

  // 确定
  confirm() {
    if (this.currActive == -1) {
      this.$message.info("请先选择待办事项");
      return;
    }
    this.pageHandle(this.list[this.currActive]);
  }
}
